// extracted by mini-css-extract-plugin
export default {"submenu":"menu_submenu__FhDHY"};